<script setup>
import { onMounted } from "vue";
import Chart from "chart.js/auto";

const props = defineProps({
    id: {
        type: String,
        required: true,
    },
    height: {
        type: String,
        default: "300",
    },
    chart: {
        type: Object,
        required: true,
        labels: Array,
        datasets: {
            type: Array,
            label: String,
            data: Array,
        },
    },
});

const config = {
    type: 'bar',
    data: {
        labels: props.chart.labels,
        datasets: [{
            label: props.chart.datasets[0].label,
            data: [12, 19, 3, 5, 2, 3],
            borderWidth: 1
        }]
    },
    options: {
        responsive: true,
        scales: {
            y: {
                beginAtZero: true
            }
        }
    }
}

onMounted(() => {
    const canvasTag = document.getElementById(props.id);
    new Chart(
        canvasTag,
        config
    )
})
</script>

<template>
    <canvas :id="props.id" class="chart-canvas" :height="props.height">
    </canvas>
</template>